export default __webpack_public_path__ + "static/in-w2-amazon-main-diagram-en1-5bd0037fa56f039f95fb4d260ccdce33.webp";